// src/config.js
// App configuration populated at boot from the backend's /api/config/ response.
// Values are exported as live bindings; call applyRuntimeConfig() before
// rendering. Consumers must read them at call time, not at import time.

export let SYSTEM_NAME = "XLerate";
export let APP_ENVIRONMENT = "";
export let APP_VERSION = "unknown";

// IT support contact, shown in the Sign-in footer.
export let SUPPORT_CONTACT = {
  email: "",
  phone: "",
};

// Same-origin API path. The dev server, Static Web Apps, and nginx all proxy it.
export const API_BASE_URL = "/api";

export function applyRuntimeConfig(config) {
  SYSTEM_NAME = config.systemName;
  APP_ENVIRONMENT = config.appEnvironment;
  APP_VERSION = config.appVersion;
  SUPPORT_CONTACT = { ...config.support };

  if (APP_ENVIRONMENT === "UAT" || APP_ENVIRONMENT === "DEV") {
    console.log(`APP_ENVIRONMENT=${APP_ENVIRONMENT}`);
  }
}
